import { createReducer, on } from '@ngrx/store';
import * as CashPaymentTypesActions from './cash-payment-types.actions';
import { otcCatalog } from 'src/app/pages/orders/interfaces/oneTimeCustomer.interface';

export interface CashPaymentTypesState {
  response: otcCatalog[] | null;
  error: any | null;
  loading: boolean;
  cache?: { [key: string]: otcCatalog[] };
}

export const initialState: CashPaymentTypesState = {
  response: null,
  error: null,
  loading: false,
  cache: {},
};

export const cashPaymentTypesReducer = createReducer(
  initialState,
  on(CashPaymentTypesActions.loadCashPaymentTypes, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(CashPaymentTypesActions.loadCashPaymentTypesSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    response,
    error: null,
  })),
  on(CashPaymentTypesActions.loadCashPaymentTypesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(CashPaymentTypesActions.loadCashPaymentTypesSuccessByKey, (state, { key, response }) => ({
    ...state,
    loading: false,
    response,
    cache: { ...(state.cache || {}), [key]: response },
    error: null,
  })),
);
